import { render, staticRenderFns } from "./RecommendationsList.vue?vue&type=template&id=433bab38&"
import script from "./RecommendationsList.vue?vue&type=script&lang=js&"
export * from "./RecommendationsList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports